import { normalize } from "polished";
import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
${normalize()}
:root {
  font-size: 16px;
  line-height: 1.5;
  color-scheme: light;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

*, *::after, *::before {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  text-decoration: none;
}

body {
  margin: 0;
  min-height: 100vh;
  /* background and color deferred to CSS variables in style.css */
  background: var(--bg, #fafaf8);
  color: var(--text-1, #141414);
}

::selection {
  background: #ffd23f;
  color: #141414;
}
`;
